import React, { useEffect, useState } from "react";
import { api, brl } from "../../lib/api";
import { BarChart3, Filter, Download, TrendingUp, Trophy } from "lucide-react";

const PURPLE = "#2B1E4A";
const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function AdminEletrosRelatorios() {
  const [exec, setExec] = useState(null);
  const [rep, setRep] = useState(null);
  const [ranking, setRanking] = useState([]);
  const [f, setF] = useState({ period: "30d", date_from: "", date_to: "" });

  const loadExec = async () => setExec((await api.get("/eletros/reports/executive")).data);
  const loadReport = async () => {
    const params = f.period === "custom" ? { date_from: f.date_from, date_to: f.date_to, scope: "admin" } : { period: f.period, scope: "admin" };
    const [r, rk] = await Promise.all([
      api.get("/eletros/reports/financial", { params }),
      api.get("/eletros/reports/ranking", { params }),
    ]);
    setRep(r.data); setRanking(rk.data);
  };
  useEffect(() => { loadExec(); loadReport(); /* eslint-disable-line */ }, []);

  const exportUrl = (fmt) => {
    const token = localStorage.getItem("cl_access_token");
    const q = f.period === "custom" ? `date_from=${f.date_from}&date_to=${f.date_to}` : `period=${f.period}`;
    return `${API_BASE}/api/eletros/reports/financial/export?fmt=${fmt}&${q}&auth=${token}`;
  };
  const doExport = async (fmt) => {
    const params = f.period === "custom" ? { date_from: f.date_from, date_to: f.date_to, fmt } : { period: f.period, fmt };
    const res = await api.get("/eletros/reports/financial/export", { params, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = `eletros_relatorio.${fmt === "xlsx" ? "xlsx" : "csv"}`;
    a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6 p-4 lg:p-8" data-testid="admin-eletros-relatorios-page">
      <div className="flex items-center gap-3 rounded-2xl p-5 text-white" style={{ background: `linear-gradient(135deg, ${PURPLE}, #5B2CA0)` }}>
        <div className="grid h-12 w-12 place-items-center rounded-xl" style={{ background: "#F5B400" }}><BarChart3 size={24} className="text-[#2B1E4A]" /></div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: "#F5B400" }}>Eletros</div>
          <h1 className="font-display text-xl font-bold">Relatorios & Gestao</h1>
        </div>
      </div>

      {/* Executivo */}
      {exec && (
        <div data-testid="exec-dashboard">
          <div className="mb-2 text-[11px] font-bold uppercase tracking-widest text-[#9A8A98]">Dashboard executivo</div>
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
            {[["today", "Hoje"], ["month", "Este mes"], ["30d", "Ultimos 30 dias"]].map(([k, l]) => (
              <div key={k} className="rounded-2xl border border-border bg-white p-4" data-testid={`exec-${k}`}>
                <div className="mb-2 text-sm font-bold text-brand-dark">{l}</div>
                <div className="grid grid-cols-2 gap-2 text-[13px]">
                  <KV k="Faturamento" v={brl(exec[k].revenue)} />
                  <KV k="Recebido" v={brl(exec[k].principal_received)} />
                  <KV k="A receber" v={brl(exec[k].open_receivable)} />
                  <KV k="Inadimplencia" v={brl(exec[k].overdue)} danger />
                  <KV k="Lucro bruto" v={brl(exec[k].gross_profit)} gold />
                  <KV k="Comissoes" v={brl(exec[k].commissions_generated)} />
                </div>
              </div>
            ))}
          </div>
          <div className="mt-3 flex gap-3">
            <span className="rounded-xl bg-amber-50 px-3 py-2 text-[13px] font-semibold text-amber-800" data-testid="exec-stock-critical">Estoque critico: {exec.stock_critical}</span>
            <span className="rounded-xl bg-indigo-50 px-3 py-2 text-[13px] font-semibold text-indigo-800" data-testid="exec-wds-pending">Saques pendentes: {exec.withdrawals_pending}</span>
          </div>
        </div>
      )}

      {/* Filtros + Export */}
      <div className="flex flex-wrap items-end gap-3 rounded-2xl border border-border bg-white p-4">
        <div className="flex items-center gap-1 text-sm font-semibold text-brand-dark"><Filter size={15} /> Periodo</div>
        <select value={f.period} onChange={(e) => setF({ ...f, period: e.target.value })} data-testid="rep-period" className="inp w-auto">
          <option value="today">Hoje</option><option value="month">Este mes</option><option value="30d">30 dias</option><option value="custom">Personalizado</option>
        </select>
        {f.period === "custom" && (<>
          <input type="date" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} data-testid="rep-from" className="inp w-auto" />
          <input type="date" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} data-testid="rep-to" className="inp w-auto" />
        </>)}
        <button onClick={loadReport} data-testid="rep-apply" className="rounded-xl px-4 py-2 text-sm font-semibold text-white" style={{ background: PURPLE }}>Aplicar</button>
        <div className="ml-auto flex gap-2">
          <button onClick={() => doExport("csv")} data-testid="rep-export-csv" className="flex items-center gap-1 rounded-xl border border-border px-3 py-2 text-sm font-semibold text-[#5B2CA0]"><Download size={14} /> CSV</button>
          <button onClick={() => doExport("xlsx")} data-testid="rep-export-xlsx" className="flex items-center gap-1 rounded-xl border border-border px-3 py-2 text-sm font-semibold text-[#5B2CA0]"><Download size={14} /> Excel</button>
        </div>
      </div>

      {/* Relatorio financeiro */}
      {rep && (
        <div className="rounded-2xl border border-border bg-white p-5" data-testid="rep-financial">
          <h2 className="mb-3 flex items-center gap-2 font-display text-base font-bold text-brand-dark"><TrendingUp size={18} className="text-[#5B2CA0]" /> Relatorio financeiro</h2>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            <KV k="Vendas" v={String(rep.sales_count)} big />
            <KV k="Faturamento" v={brl(rep.revenue)} big />
            <KV k="Principal recebido" v={brl(rep.principal_received)} big />
            <KV k="A receber" v={brl(rep.open_receivable)} big />
            <KV k="Inadimplencia" v={`${brl(rep.overdue)} (${rep.overdue_pct}%)`} big danger />
            <KV k="Custo (CMV)" v={brl(rep.cogs)} big />
            <KV k="Lucro bruto" v={brl(rep.gross_profit)} big gold />
            <KV k="Margem media" v={`${rep.margin_avg}%`} big />
            <KV k="Comissoes geradas" v={brl(rep.commissions_generated)} big />
            <KV k="Responsabilidades" v={brl(rep.responsibilities_assumed)} big />
            <KV k="Recuperado" v={`${brl(rep.recovered)} (${rep.recovery_rate}%)`} big />
            <KV k="Saques pagos" v={brl(rep.withdrawals_paid)} big />
            <KV k="Ticket medio" v={brl(rep.ticket_avg)} big />
            <KV k="Mais vendido" v={rep.top_product || "—"} big />
            <KV k="Categoria top" v={rep.top_category || "—"} big />
          </div>
        </div>
      )}

      {/* Ranking */}
      <div className="rounded-2xl border border-border bg-white p-5" data-testid="rep-ranking">
        <h2 className="mb-3 flex items-center gap-2 font-display text-base font-bold text-brand-dark"><Trophy size={18} className="text-[#C9960A]" /> Ranking de revendedoras</h2>
        {ranking.length === 0 ? <div className="py-4 text-center text-sm text-[#9A8A98]">Sem dados no periodo.</div> : (
          <div className="overflow-x-auto">
            <table className="w-full text-[13px]">
              <thead><tr className="text-left text-[10px] uppercase tracking-widest text-[#9A8A98]">
                <th className="py-2">Revendedora</th><th>Faturamento</th><th>Recebido</th><th>Carteira</th><th>Comissao</th><th>Inadimpl.</th><th>Recuper.</th><th>Ticket</th>
              </tr></thead>
              <tbody>
                {ranking.map((r) => (
                  <tr key={r.reseller_id} className="border-t border-border/50" data-testid={`rank-${r.reseller_id}`}>
                    <td className="py-2 font-medium text-brand-dark">{r.reseller_name}</td>
                    <td>{brl(r.revenue)}</td><td>{brl(r.principal_received)}</td><td>{brl(r.open_receivable)}</td>
                    <td>{brl(r.commissions_generated)}</td>
                    <td className={r.overdue_pct > 0 ? "text-red-600" : ""}>{r.overdue_pct}%</td>
                    <td>{r.recovery_rate}%</td><td>{brl(r.ticket_avg)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function KV({ k, v, big, danger, gold }) {
  const color = danger ? "#DC2626" : gold ? "#C9960A" : PURPLE;
  return (
    <div className={big ? "rounded-xl border border-border p-3" : ""}>
      <div className="text-[10px] uppercase tracking-widest text-[#9A8A98]">{k}</div>
      <div className={`font-display font-bold ${big ? "text-base" : "text-sm"}`} style={{ color }}>{v}</div>
    </div>
  );
}
